function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M12 18a1 1 0 01-.64-.23C11.1 17.55 5 12.41 5 6.85A6.93 6.93 0 0112 0c3.86 0 7 3.07 7 6.85 0 5.56-6.1 10.7-6.36 10.92A1 1 0 0112 18zm0-16C9.24 2 7 4.17 7 6.85c0 3.67 3.52 7.4 5 8.8 1.48-1.4 5-5.13 5-8.8A4.93 4.93 0 0012 2z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 12,
  cy: 7,
  r: 2
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M23 23H1a1 1 0 01-.92-1.4l3-7A1 1 0 014 14h2a1 1 0 011 1 1 1 0 01-1 1H4.66l-2.14 5h18.96l-2.14-5H18a1 1 0 01-1-1 1 1 0 011-1h2a1 1 0 01.92.6l3 7A1 1 0 0123 23z"
});

var SvgIconMap = function SvgIconMap(props) {
  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 24",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.41
  }, props), _ref, _ref2, _ref3);
};

export default SvgIconMap;